import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, withStyles, Typography } from '@material-ui/core'
import ReactSelect from 'components/theme/Select'
import { selectContactsForGroup, selectEndpoint } from 'actions/tasks'
import { contactOptionsSelector } from 'selectors'
import { list } from 'actions/data'
import { toggleDialog } from 'actions/view'
import AddOrEditEndpointDialog from 'components/AddOrEditEndpointDialog'

const styles = theme => ({
  paper: {
    [theme.breakpoints.down('sm')]: {
      padding: 20,
    },
  },
})

const HttpSendData = ({
  contactOptions,
  contactsSelectedForGroup,
  automationTypeSelected,
  selectContactsForGroup,
  classes,
  endpoints,
  list,
  selectEndpoint,
  endpointSelected,
  toggleDialog,
}) => {
  useEffect(() => {
    console.log('should only run once')
    list('endpoint')
  }, [list])

  const customStyles = {
    control: provided => ({
      ...provided,
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderRadius: '28px',
      padding: '9px 0',
    }),
    menu: provided => ({
      ...provided,
      zIndex: 2,
    }),
  }

  const endpoint = endpoints?.[endpointSelected]
  const value = {
    value: endpoint?.id,
    label: endpoint?.name,
    key: `${endpoint?.id}-Endpoint`,
  }

  const endpointOptions = Object.values(endpoints || {}).map(tpe => ({
    value: tpe.id,
    label: tpe.name,
    key: `${tpe.id}-Pool`,
  }))

  const selectWithLabel = (
    <>
      <Typography variant="h5" gutterBottom>
        {`Select the third party endpoint you want to send data to`}
      </Typography>
      <ReactSelect
        styles={customStyles}
        value={value}
        onChange={newValue => {
          console.log(newValue)
          if (newValue.value === 'new') {
            toggleDialog({
              open: true,
              dialog: 'AddOrEditEndpoint',
            })
          } else {
            selectEndpoint(newValue.value)
          }
        }}
        closeMenuOnSelect
        isMulti={false}
        options={[
          {
            // endpointID: 'new',
            value: 'new',
            label: 'Create new endpoint',
          },
          ...endpointOptions,
        ]}
        placeholder="Selected third party endpoint"
      />
    </>
  )

  return (
    <>
      <div className={classes.paper}>
        <Grid container spacing={16}>
          {automationTypeSelected === 'stage' ? (
            <Grid item xs={12}>
              {selectWithLabel}
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Typography variant="h5" gutterBottom>
                {`Select the contacts that you want to send to a third party endpoint`}
              </Typography>
              <ReactSelect
                styles={customStyles}
                value={contactsSelectedForGroup}
                onChange={newValue => selectContactsForGroup(newValue)}
                closeMenuOnSelect={false}
                isMulti
                options={contactOptions}
                placeholder="Selected contacts"
              />
              <div style={{ height: 20 }} />
              {selectWithLabel}
            </Grid>
          )}
        </Grid>
      </div>
      <AddOrEditEndpointDialog
        thenFunc={payload => {
          selectEndpoint(payload?.id)
          toggleDialog({ open: false, dialog: 'AddOrEditEndpoint' })
        }}
      />
    </>
  )
}

export default connect(
  state => ({
    contactOptions: contactOptionsSelector(state),
    contactsSelectedForGroup: state.tasks.addOrEdit.contactsSelectedForGroup,
    automationTypeSelected: state.tasks.addOrEdit.automationTypeSelected,
    // taskID: state.tasks.addOrEdit.taskID,
    endpoints: state.data?.endpoint,
    endpointSelected: state.tasks.addOrEdit.endpointSelected,
  }),
  dispatch =>
    bindActionCreators(
      { selectContactsForGroup, list, toggleDialog, selectEndpoint },
      dispatch,
    ),
)(withStyles(styles)(HttpSendData))
